import { makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';
import { MOBILE_BREAKPOINT } from '../../../../config/constants';

export const useStyles = makeStyles<Theme>(theme => ({
    container: {
        flex: 1,
        justifyContent: 'flex-start',
        alignSelf: 'center',
        [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
            width: '100%',
            maxWidth: '100%',
            marginTop: '0',
        },
        [theme.breakpoints.up(MOBILE_BREAKPOINT)]: {
            marginTop: '2rem',
        },
        [theme.breakpoints.down('md')]: {
            marginBottom: '2rem',
        },
        [theme.breakpoints.between('lg', 'xl')]: {
            maxWidth: 1300,
        },
        [theme.breakpoints.up('xl')]: {
            maxWidth: 1500,
            marginTop: '3rem',
        },
    },
    title: {
        color: 'black',
        fontSize: '19px',
        fontWeight: 500,
        [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
            marginTop: 0,
        },
    },
    infoRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '1rem',
        marginBottom: '16px',
        [theme.breakpoints.up(MOBILE_BREAKPOINT)]: {
            marginLeft: '-0.5rem',
        },
        [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
            marginLeft: '-0.2rem',
        },
        '& img': {
            width: '30px',
        },
        '& p': {
            marginTop: 0,
            marginBottom: 0,
            fontWeight: 400,
            fontSize: '16px',
        },
    },
    infoText: {
        borderBottom: '1px solid #D8DCE5',
        minWidth: '175px',
        maxWidth: '300px',
        color: 'grey',
        [theme.breakpoints.up('md')]: {
            width: '300px',
        },
    },
    policies: {
        [theme.breakpoints.up('lg')]: {
            paddingLeft: '5rem',
        },
        [theme.breakpoints.up(MOBILE_BREAKPOINT)]: {
            paddingTop: '1.5rem',
        },
        [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
            paddingLeft: '0px',
            paddingTop: '2rem',
        },
        '& h4': {
            fontSize: '1.5rem',
            marginTop: 0,
            marginBottom: '0.5rem',
            fontWeight: 400,
        },
        '& p': {
            marginTop: 0,
            marginBottom: '1rem',
            color: 'grey',
            [theme.breakpoints.up('lg')]: {
                width: '45rem',
                padding: '0 8rem 0rem 0',
            },
        },
    },
    topBorder: {
        [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
            marginLeft: '1rem',
        },
        [theme.breakpoints.between(MOBILE_BREAKPOINT, 'md')]: {
            paddingLeft: '2rem',
            paddingRight: '2rem',
        },
        [theme.breakpoints.up('lg')]: {
            borderTopWidth: 1,
            borderTopStyle: 'solid',
            borderTopColor: theme.palette.secondary.light,
        },
    },
    cancelButton: {
        borderRadius: '50px',
        padding: '10px 20px',
        fontSize: '15px',
        height: '34px',
        border: 0,
        backgroundColor: theme.palette.secondary.light,
        color: 'white',
        marginTop: '0.5rem',
    },
}));
